
export const COMPANY_INFO = {
    name: "Vasu Nath Enterprises",
    address: "23A, B9/8, Srijan Apartment, Sector 62, Noida – 201301, Uttar Pradesh, India",
    phones: ["+91 9958200988", "+91 8830490358"],
    whatsapp: "+919958200988",
    email: "contact@vasunath.com", // Placeholder
    hours: {
        weekdays: "8:00 – 19:00",
        saturday: "8:00 – 14:00",
        sunday: "Closed"
    }
};

export const NAV_LINKS = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Solutions", path: "/solutions" },
    { name: "Products", path: "/products" },
    { name: "Contact Us", path: "/contact" },
];

export const MARKET_AREAS = [
    { name: "Delhi", path: "/market/delhi", image: "https://images.unsplash.com/photo-1705077171489-b5dfcf144676?auto=format&fit=crop&w=1920&q=80" },
    { name: "Gurgaon", path: "/market/gurgaon", image: "https://images.unsplash.com/photo-1705077171489-b5dfcf144676?auto=format&fit=crop&w=1920&q=80" }, 
    { name: "Noida", path: "/market/noida", image: "https://images.unsplash.com/photo-1705077171489-b5dfcf144676?auto=format&fit=crop&w=1920&q=80" }, 
    { name: "Ghaziabad", path: "/market/ghaziabad", image: "https://images.unsplash.com/photo-1705077171489-b5dfcf144676?auto=format&fit=crop&w=1920&q=80" }, 
    { name: "Manesar", path: "/market/manesar", image: "https://images.unsplash.com/photo-1705077171489-b5dfcf144676?auto=format&fit=crop&w=1920&q=80" }, 
    { name: "Delhi & NCR", path: "/market/delhi-ncr", image: "https://images.unsplash.com/photo-1705077171489-b5dfcf144676?auto=format&fit=crop&w=1920&q=80" },
    { name: "Mumbai", path: "/market/mumbai", image: "https://images.unsplash.com/photo-1625731226721-b4d51ae70e20?auto=format&fit=crop&w=1920&q=80" },
    { name: "Bangalore", path: "/market/bangalore", image: "https://images.unsplash.com/photo-1687158266872-fd2773fa76c6?auto=format&fit=crop&w=1920&q=80" },
    { name: "Hyderabad", path: "/market/hyderabad", image: "https://images.unsplash.com/photo-1657981630164-769503f3a9a8?auto=format&fit=crop&w=1920&q=80" },
    { name: "Chennai", path: "/market/chennai", image: "https://images.unsplash.com/photo-1566393612878-2e68d73691a3?auto=format&fit=crop&w=1920&q=80" },
    { name: "Kolkata", path: "/market/kolkata", image: "https://images.unsplash.com/photo-1666876419569-bd714131b4c1?auto=format&fit=crop&w=1920&q=80" },
    { name: "Pune", path: "/market/pune", image: "https://images.unsplash.com/photo-1705954797147-652784bc2484?auto=format&fit=crop&w=1920&q=80" },
    { name: "Ahmedabad", path: "/market/ahmedabad", image: "https://images.unsplash.com/photo-1587831990711-23ca6441447b?auto=format&fit=crop&w=1920&q=80" } 
];

export const GEM_PORTFOLIO = [
    { 
        brand: "HP", 
        products: "Laptop, Desktop, All in One, Printers, Multifunction Printers, A3 Printers, Scanner, Servers, Workstation",
        logo: "https://customer-assets.emergentagent.com/job_print-tech-supply/artifacts/1b3ty9gc_1.png"
    },
    { 
        brand: "Acer", 
        products: "Laptop, Desktop, All in One, Monitor"
    },
    { 
        brand: "LG", 
        products: "AC, Smart Television TV, Microwave, Washing Machine, Refrigerators - Fridge, Smart Interective Panel"
    },
    { 
        brand: "Seagate", 
        products: "Internal & External Hard Disc"
    },
    { 
        brand: "Microtek", 
        products: "UPS, Online UPS"
    },
    { 
        brand: "Brother", 
        products: "Computer Printer & Multifunction Printer"
    },
    { 
        brand: "Benq", 
        products: "Projector"
    },
    { 
        brand: "Kent", 
        products: "RO system, Fan, Air Purifiers"
    },
    { 
        brand: "Ahuja", 
        products: "Speaker"
    },
    { 
        brand: "Panasonic", 
        products: "TV & Large Format Display - Interective Panel"
    },
    { 
        brand: "Nikon", 
        products: "Camera"
    },
    { 
        brand: "Vertiv (Emerson)", 
        products: "UPS & Online UPS",
        logo: "https://customer-assets.emergentagent.com/job_print-tech-supply/artifacts/m9mx5ib5_15.png"
    },
    // Strategic Partners (for slider)
    { 
        brand: "Poly", 
        products: "Video Conferencing, Headsets, Phones, Collaboration Solutions",
        logo: "https://customer-assets.emergentagent.com/job_print-tech-supply/artifacts/9ciqmcrq_3.png"
    },
    { 
        brand: "Netmagic", 
        products: "Cloud Infrastructure, Managed Hosting, Data Center Services",
        logo: "https://customer-assets.emergentagent.com/job_print-tech-supply/artifacts/yklv7z96_4.jpg"
    },
    { 
        brand: "Veeam", 
        products: "Data Backup, Recovery, Data Management",
        logo: "https://customer-assets.emergentagent.com/job_print-tech-supply/artifacts/bsgnlk4j_5.png"
    },
    { 
        brand: "NetApp", 
        products: "Cloud Data Services, Storage Systems, Software",
        logo: "https://customer-assets.emergentagent.com/job_print-tech-supply/artifacts/g79777yy_7.png"
    },
    { 
        brand: "Schneider Electric", 
        products: "Energy Management, Automation Solutions",
        logo: "https://customer-assets.emergentagent.com/job_print-tech-supply/artifacts/l5yhjhil_9.png"
    },
    { 
        brand: "Avaya", 
        products: "Business Communications, Contact Center Solutions",
        logo: "https://customer-assets.emergentagent.com/job_print-tech-supply/artifacts/hhxdrbhk_14.png"
    },
    { 
        brand: "Citrix", 
        products: "Virtualization, Networking, Cloud Computing",
        logo: "https://customer-assets.emergentagent.com/job_print-tech-supply/artifacts/nmvuw5cc_12.png"
    },
    { 
        brand: "Cisco", 
        products: "Networking, Cloud, Cybersecurity Solutions",
        logo: "https://customer-assets.emergentagent.com/job_print-tech-supply/artifacts/lfn2mfrs_10.jpg"
    },
    { 
        brand: "Microsoft", 
        products: "Software, Cloud Solutions, Surface Devices",
        logo: "https://customer-assets.emergentagent.com/job_print-tech-supply/artifacts/o8nlmdcm_13.png"
    }
];

export const PRODUCTS = [
    {
        id: 1,
        name: "Heavy Duty Printers",
        description: "High-volume printing solutions for enterprise needs.",
        category: "Printers",
        image: "https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?auto=format&fit=crop&w=800&q=80"
    },
    {
        id: 2,
        name: "Enterprise Desktops",
        description: "Reliable workstations for maximum productivity.",
        category: "Computers",
        image: "https://images.unsplash.com/photo-1593640495253-23196b27a87f?auto=format&fit=crop&w=800&q=80"
    },
    {
        id: 3,
        name: "Printer Ink & Consumables",
        description: "Genuine supplies for all major printer brands.",
        category: "Supplies",
        image: "https://images.unsplash.com/photo-1706895040634-62055892cbbb?auto=format&fit=crop&w=800&q=80"
    },
    {
        id: 4,
        name: "Storage Solutions",
        description: "High-capacity hard disks and SSDs.",
        category: "Storage",
        image: "https://images.unsplash.com/photo-1564457461758-8ff96e439e83?auto=format&fit=crop&w=800&q=80"
    },
    {
        id: 5,
        name: "Business Laptops",
        description: "Portable powerhouses for the modern workforce.",
        category: "Computers",
        image: "https://images.unsplash.com/photo-1587831990711-23ca6441447b?auto=format&fit=crop&w=800&q=80"
    }
];

export const SOLUTIONS = [
    {
        id: 1,
        title: "Smart Workspaces",
        description: "Transform your office with integrated IT infrastructure that enhances collaboration and efficiency.",
        image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80",
        features: ["Network Integration", "Wireless Solutions", "Modern Workstations"]
    },
    {
        id: 2,
        title: "Digital Classrooms",
        description: "Empower learning with state-of-the-art educational technology and computer lab setups.",
        image: "https://images.pexels.com/photos/3747473/pexels-photo-3747473.jpeg?auto=format&fit=crop&w=800&q=80",
        features: ["Interactive Displays", "Lab Networking", "Student Workstations"]
    },
    {
        id: 3,
        title: "Document Management",
        description: "Streamline your workflow with high-speed scanning and secure printing solutions.",
        image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=800&q=80",
        features: ["Cloud Archiving", "Secure Printing", "Automated Workflows"]
    }
];

export const HERO_IMAGES = [
    "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1920&q=80", // Office People
    "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1920&q=80", // Server Room
    "https://images.unsplash.com/photo-1644079446600-219068676743?auto=format&fit=crop&w=1920&q=80"  // Warehouse
];
